import type { PrintBatchLabelsInput, PrintCellLabelsInput } from '@eombor/contracts';
import { apiClient } from '../../auth/model/auth.store.js';
import type { ApiClient } from '../../../shared/api/client.js';

/**
 * Etiketka bosish. Manba: `labeling/infrastructure/http/label.controller.ts`.
 *
 * Javob **binar PDF**, `{ data }` konvertida emas — shuning uchun `apiBlob`
 * ishlatiladi. Faylni saqlash brauzerning o'z ishi: biz `Blob` ni qaytaramiz
 * va chaqiruvchi uni ochadi yoki yuklaydi.
 */
export interface LabelApi {
  printCells: (input: PrintCellLabelsInput) => Promise<Blob>;
  /** MAHSULOT etiketkasi — partiya bo'yicha, qutiga yopishtiriladi. */
  printBatches: (input: PrintBatchLabelsInput) => Promise<Blob>;
}

export const createLabelApi = (client: ApiClient): LabelApi => ({
  printCells: (input) =>
    client.apiBlob('/labels/cells', { method: 'POST', body: JSON.stringify(input) }),
  printBatches: (input) =>
    client.apiBlob('/labels/batches', { method: 'POST', body: JSON.stringify(input) }),
});

export const labelApi = createLabelApi(apiClient);

export const LABEL_FILE_NAME = 'etiketkalar.pdf';

/**
 * Faylni saqlash `shared/api/download.ts` ga ko'chirildi: buxgalteriya
 * hujjatlari ham AYNAN shu yo'ldan yuklanadi va qoida ikki joyda ayri
 * ketmasligi kerak. Bu yerdan qayta chiqariladi — chaqiruvchilar tegilmadi.
 */
export { downloadBlob } from '../../../shared/api/download.js';
